module.exports = __webpack_public_path__ + "static/media/data-file.9a34aa73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-file.svg
// module id = 963
// module chunks = 0